import {
  FloatingFocusManager,
  FloatingOverlay,
  FloatingPortal,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from "@floating-ui/react";
import clsx from "clsx";
import { useDrawerContext } from "./drawer";

export interface DrawerFloatingProps extends React.HTMLAttributes<HTMLDivElement> {
  floatingPortalId: string;
  direction?: "left" | "right";
  disableClose?: boolean;
}

export function DrawerFloating(props: Readonly<DrawerFloatingProps>) {
  const {
    floatingPortalId,
    direction = "left",
    disableClose = false,
    ...rest
  } = props;

  const { open, setOpen } = useDrawerContext();
  const { refs, context } = useFloating({
    open,
    onOpenChange: setOpen,
  });

  const { getFloatingProps } = useInteractions([
    useClick(context),
    useRole(context),
    useDismiss(context, {
      outsidePress: !disableClose,
      outsidePressEvent: "mousedown",
    }),
  ]);

  return (
    <FloatingPortal id={floatingPortalId}>
      <div className="h-screen">
        {open && (
          <FloatingOverlay lockScroll className="z-10 bg-[rgba(0,0,0,0.8)]" />
        )}
        <FloatingFocusManager context={context} modal closeOnFocusOut>
          <div
            ref={refs?.setFloating}
            {...getFloatingProps({
              ...rest,
              className: clsx(
                "z-50 h-screen absolute top-0 transition-transform duration-300",
                {
                  "-translate-x-full": !open && direction === "left",
                  "translate-x-full": !open && direction === "right",
                  "left-0": direction === "left",
                  "right-0": direction === "right",
                },
              ),
            })}
          />
        </FloatingFocusManager>
      </div>
    </FloatingPortal>
  );
}
